export default "__VITE_ASSET__DX8X42zT__"